<template>
  <v-text-field
    :label="label"
    v-model="fileName"
    :hint="hint"
    persistent-hint
    readonly
    :error="error"
    :error-messages="errorMessages"
    :loading="$refs.singleUpload && $refs.singleUpload.active"
  >
    <v-progress-linear
      v-if="$refs.singleUpload && $refs.singleUpload.active"
      slot="progress"
      v-model="progress"
      height="2">
    </v-progress-linear>

    <file-upload
      :input-id="inputId"
      slot="append-outer"
      class="blue--text text--darken-1 v-btn v-btn--small v-btn--depressed"
      :post-action="action"
      :chunk-enabled="chunkEnabled"
      :chunk="{
            action: action,
            minSize: chunkMinSize,
            maxActive: chunkMaxActive,
            maxRetries: chunkMaxRetries
          }"
      :extensions="extensions"
      :accept="accept"
      :multiple=false
      :directory="false"
      :data="{group: group}"
      :size="size * 1024 * 1024"
      v-model="files"
      @input-filter="inputFilter"
      @input-file="inputFile"
      ref="singleUpload">
      <div id="upload-btn" class="v-btn__content" style="height: 100%">
        上传
      </div>
    </file-upload>

    <div
      v-if="$refs.singleUpload && $refs.singleUpload.active"
      slot="append">
      <v-btn
        color="primary"
        small
        depressed
        :disabled="!$refs.singleUpload || !$refs.singleUpload.active"
        @click="$refs.singleUpload.active =false"
      >
        {{$refs.singleUpload && $refs.singleUpload.active? (files[0].progress )+'%' : ""}}
        取消
      </v-btn>
    </div>
  </v-text-field>

</template>

<script>
  import FileUpload from 'vue-upload-component'

  export default {
    props: {
      value: {
        type: Object,
        default: () => {
        }
      },
      inputId: {
        type: String,
        default: () => Math.random().toString(36).substr(2)
      },
      label: {
        type: String,
        default: () => ""
      },
      action: {
        type: String,
        default: () => ""
      },
      size: {
        // 单位 M
        type: Number,
        default: () => 10
      },
      multiple: {
        type: Boolean,
        default: () => true
      },
      extensions: {
        type: String,
        default: () => "gif,jpg,jpeg,png,webp,pdf"
      },

      accept: {
        type: String,
        default: () => "image/png,image/gif,image/jpeg,image/webp,application/pdf"
      },

      group: {
        type: String,
        default: () => null
      },

      hint: {
        type: String,
        default: () => ""
      }
    },

    components: {FileUpload},
    data() {
      return {
        fileName: '',

        files: [],
        chunkEnabled: true,
        chunkMinSize: 0, // force to use chunked singleUpload.
        chunkMaxActive: 3,
        chunkMaxRetries: 5,

        errors: {
          size: `文件超过 ${this.size}M.`,
          extension: "文件类型错误.",
          timeout: "上传超时.",
          abort: "已取消上传.",
          network: "网络错误",
          server: "服务器错误.",
          denied: "禁止上传."
        }
      }
    },

    watch: {
      value(nv, ov) {
        // window.console.log("in Single Uploader value.");
        // window.console.log(nv);

        // 控件与数据已同步
        if (nv && nv.local) return;

        // 正在上传文件
        if (this.$refs.singleUpload.active) return;

        // 新建，清空上传记录
        if ((!nv || !Object.keys(nv).length)) {
          this.$refs.singleUpload.clear();
          return;
        }

        // *****用远程文件信息，填充上传记录*****

        // 远程文件默认值
        const remoteDefault = {
          dbid: null,
          file: null,
          name: null,
          size: null,
          type: null,

          fileObject: true,
          success: true,
          progress: "100.00",
          active: false,
          response: {},
          speed: 0,
          timeout: 0,
        };

        // 文件对象
        const fileObj = Object.assign(
          {},
          remoteDefault,
          {
            dbid: nv.dbid,
            // file: file,
            name: nv.fileName,
            size: nv.size,
            type: nv.contentType
          }
        );

        // 删除控件中的，原有文件
        //this.$refs.singleUpload.clear();
        this.$refs.singleUpload.add(fileObj);

        // 更新文件信息
        this.$emit('input', Object.assign(nv, {local: true}));
      }
    },

    computed: {
      error() {
        return (
          this.files[0] ?
            (!!(this.files[0].error && this.files[0].error.length > 0))
            : false);
      },
      errorMessages() {
        if (this.files[0]) window.console.log(this.files[0].error);

        return this.files[0] ? this.errors[this.files[0].error] : "";
      },

      progress() {
        return this.files[0] ? this.files[0].progress : "0.00"
      }
    },

    methods: {
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // 添加文件前
          // Filter system files or hide files
          // 过滤系统文件 和隐藏文件
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          // 过滤 php html js 文件
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          // Add file
          // window.console.log('add', newFile);
          // 显示文件名
          this.fileName = newFile.name;
        }

        if (newFile && oldFile) {
          // Update file
          // Start upload
          if (newFile.active !== oldFile.active) {
            // window.console.log('Start upload', newFile.active, newFile)
          }

          // 获取服务器端文件主键（sessionId --> dbid）
          if (newFile.chunk && !newFile.dbid) {
            this.$refs.singleUpload.update(newFile, {dbid: newFile.chunk.sessionId})
          }

          // Upload progress
          if (newFile.progress !== oldFile.progress) {
            // window.console.log('progress', newFile.progress, newFile)
          }

          // Upload error
          if (newFile.error !== oldFile.error) {
            // window.console.log('error', newFile.error, newFile)
          }

          // Uploaded successfully
          if (newFile.success && newFile.dbid) {
            // window.console.log('success', newFile.success, newFile);

            // 文件上传完成
            if (newFile.dbid && newFile.success) {
              const nv = {
                dbid: newFile.dbid,
                fileName: newFile.name,
                contentType: newFile.type,
                size: newFile.size,
                local: true
              };
              this.$emit('input', window.xutil.clone(nv));
            }
          }
        }

        if (!newFile && oldFile) {
          // Remove file

          // remove
          // window.console.log('remove', oldFile);

          // 文件上传完成
          if (oldFile.dbid && oldFile.success) {
            this.$emit('input', {});
          }
        }

        // Automatic upload
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          if (!this.$refs.singleUpload.active) {
            this.$refs.singleUpload.active = true
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>
